const alphabeticallyOrderedArray = (options, keyToOrder) => options
  .sort((a, b) => a[keyToOrder].localeCompare(b[keyToOrder]));

export default alphabeticallyOrderedArray;
